import { useEffect, useRef } from 'react';
import { useTheme } from '../context/ThemeContext';

export const useIframeThemeSync = (iframeRef, baseUrl, additionalParams = {}) => {
  const { theme } = useTheme();
  
  const updateIframeTheme = () => {
    if (!iframeRef.current) return;
    
    try {
      // Method 1: Update iframe src with new theme
      const currentSrc = iframeRef.current.src;
      const url = new URL(currentSrc);
      url.searchParams.set('theme', theme);
      
      // Preserve other parameters
      Object.entries(additionalParams).forEach(([key, value]) => {
        if (value) {
          url.searchParams.set(key, value);
        }
      });
      
      // Force iframe reload with new theme
      iframeRef.current.src = url.toString();
      
      // Method 2: Send postMessage for immediate theme change (if supported)
      if (iframeRef.current.contentWindow) {
        iframeRef.current.contentWindow.postMessage(
          { 
            type: "themeChange", 
            payload: { theme: theme },
            timestamp: Date.now()
          },
          "*"
        );
      }
    } catch (error) {
      console.warn('Failed to update iframe theme:', error);
    }
  };
  
  useEffect(() => {
    updateIframeTheme();
  }, [theme]);
  
  return { updateIframeTheme };
};
